import PhotoHeart from '../src/LikingPhotos/PhotoHeart.tsx';
export default PhotoHeart;
